import Vue from 'vue'
import Swal from 'sweetalert2'

const HelperSwal = {
  data() {
    return {
      swalToast: true,
      swalTimer: 3000,
      swalIcon: 'success',
      swalPosition: 'center-end',
      swalShowConfirmButton: false,
      swalTimerProgressBar: true,
      swalShowCancelButton: true,
      swalShowLoaderOnConfirm: true,
      swalAllowOutsideClick: false,
      swalTitle: '',
      swalText: '',
    }
  },
  methods: {
    setupSwal() {
      return Swal.mixin({
        timer: this.swalTimer,
        cancelButtonColor: '#d33',
        confirmButtonColor: '#3085d6',
        position: this.swalPosition,
        confirmButtonText: this.$t('ok'),
        cancelButtonText: this.$t('cancel'),
        showCancelButton: this.swalShowCancelButton,
        timerProgressBar: this.swalTimerProgressBar,
        showConfirmButton: this.swalShowConfirmButton,
        showLoaderOnConfirm: this.swalShowLoaderOnConfirm,
        allowOutsideClick: () => this.swalAllowOutsideClick,
      })
    },
    /**
     * @param {String} icon
     * @param {String} position
     */
    defaultSettingsToastSwal(icon, position) {
      this.swalToast = true
      this.swalTimer = 3000
      this.swalIcon = this.checkVariable(icon) ? icon : 'success'
      this.swalPosition = this.checkVariable(position) ? position : 'center-end'
      this.swalTimerProgressBar = false
      this.swalShowConfirmButton = false
    },
    defaultSettingsSwal() {
      this.swalToast = false
      this.swalIcon = 'warning'
      this.swalTimer = undefined
      this.swalPosition = 'center'
      this.swalTimerProgressBar = false
      this.swalShowConfirmButton = true
      this.swalShowLoaderOnConfirm = true
    },
    setupSwalToast() {
      return Swal.mixin({
        toast: this.swalToast,
        timer: this.swalTimer,
        position: this.swalPosition,
        timerProgressBar: this.swalTimerProgressBar,
        showConfirmButton: this.swalShowConfirmButton,
        onOpen: (toast) => {
          toast.addEventListener('mouseenter', Swal.stopTimer)
          toast.addEventListener('mouseleave', Swal.resumeTimer)
        },
      })
    },
    positionedDialog() {
      const original = this.setupSwal()
      original.fire({
        icon: this.swalIcon,
        title: this.swalTitle,
        text: this.swalText,
      })
    },
    positionedDialogToast() {
      const toast = this.setupSwalToast()
      toast.fire({
        icon: this.swalIcon,
        title: this.swalTitle,
        text: this.swalText,
      })
    },
    toastSwalWithPositionedDialogToast(title, icon, position) {
      this.defaultSettingsToastSwal(icon, position)
      this.swalTitle = title
      this.swalText = undefined
      this.positionedDialogToast()
    },
  },
}

const Component = Vue.extend({
  name: 'helper-swal',
  mixins: [HelperSwal],
})

export default Component
